/**
 * Service Request Action Types.
 */
export const CHANGE_ACTIVE_CUSTOMER = 'CHANGE_ACTIVE_CUSTOMER'
export const END_KANDY_CALL = 'END_KANDY_CALL'
export const END_SESSION = 'END_SESSION'
export const LOAD_SERVICE_REQUESTS = 'LOAD_SERVICE_REQUESTS'
export const MAKE_KANDY_CALL = 'MAKE_KANDY_CALL'
export const START_SESSION = 'START_SESSION'
export const START_SESSION_FINISH = 'START_SESSION_FINISH'
export const CANCEL_SERVICE_REQUEST = 'CANCEL_SERVICE_REQUEST'
export const CANCEL_SERVICE_REQUEST_FINISH = 'CANCEL_SERVICE_REQUEST_FINISH'
export const CLEAR_SERVICE_REQUESTS = 'CLEAR_SERVICE_REQUESTS'
export const CREATE_ESCALATED_SERVICE_REQUEST = 'CREATE_ESCALATED_SERVICE_REQUEST'
export const UPDATE_ESCALATED_SERVICE_REQUEST = 'UPDATE_ESCALATED_SERVICE_REQUEST'
export const UPDATE_SERVICE_REQUESTS = 'UPDATE_SERVICE_REQUESTS'
export const SEND_MAIL_FINISH = 'SEND_MAIL_FINISH'
export const SEND_SMSS_FINISH = 'SEND_SMSS_FINISH'
export const CUSTOMER_DISCONNECTED = 'CUSTOMER_DISCONNECTED'
export const ISSHOW_CALL_SHADE = 'ISSHOW_CALL_SHADE'
export const CANCEL_SESSION_TRANSFER = 'CANCEL_SESSION_TRANSFER'
export const RECEIVE_SESSION_TRANSFER = 'RECEIVE_SESSION_TRANSFER'
export const RECEIVE_CANCEL_SESSION_TRANSFER = 'RECEIVE_CANCEL_SESSION_TRANSFER'
export const RECEIVE_SESSION_TRANSFER_RESPONSE = 'RECEIVE_SESSION_TRANSFER_RESPONSE'
export const SET_FREE_SWITCH_STATE = 'SET_FREE_SWITCH_STATE'
/**
 * Service Request Filters.
 */
export const ACTIVE = 'ACTIVE'
export const VOICE_CHAT = 'VOICE_CHAT'
export const TEXT_CHAT = 'TEXT_CHAT'
export const VIDEO_CHAT = 'VIDEO_CHAT'
export const ESCALATED = 'ESCALATED'
export const WX_CHAT='WX_CHAT'
/**
 * Department action types
 */
export const GET_DEPARTMENTS = 'GET_DEPARTMENTS'
export const GET_DEPARTMENTS_FINISH = 'GET_DEPARTMENTS_FINISH'

/**
 * Agent action types.
 */
export const GET_AGENT = 'GET_AGENT'
export const GET_AGENT_FINISH = 'GET_AGENT_FINISH'
export const UPDATE_AGENT = 'UPDATE_AGENT'
export const UPDATE_AGENT_FINISH = 'UPDATE_AGENT_FINISH'

export const GET_AGENTLIST = 'GET_AGENTLIST'
export const GET_AGENTLIST_FINISH = 'GET_AGENTLIST_FINISH'

export const EMAIL_PASSWORD_RESET_LINK = 'EMAIL_PASSWORD_RESET_LINK'
export const EMAIL_PASSWORD_RESET_LINK_FINISH = 'EMAIL_PASSWORD_RESET_LINK_FINISH'
export const UPDATE_AGENT_PASSWORD = 'UPDATE_AGENT_PASSWORD'
export const UPDATE_AGENT_PASSWORD_FINISH = 'UPDATE_AGENT_PASSWORD_FINISH'
export const UPDATE_CURRENTAGENT_STATE = 'UPDATE_CURRENTAGENT_STATE'
export const UPDATE_CURRENTAGENT_LOGIN_STATE = 'UPDATE_CURRENTAGENT_LOGIN_STATE'
export const UPDATE_AGENT_KANDY_STATUS = 'UPDATE_AGENT_KANDY_STATUS'

// Constants for chat actions
export const GET_CHAT_HISTORY = 'GET_CHAT_HISTORY'
export const GET_CHAT_HISTORY_FINISH = 'GET_CHAT_HISTORY_FINISH'
export const SAVE_CHAT = 'SAVE_CHAT'
export const SAVE_CHAT_FINISH = 'SAVE_CHAT_FINISH'
export const CLEAR_CHAT_HISTORY = 'CLEAR_CHAT_HISTORY'
export const CLEAR_CHAT_HISTORY_FINISH = 'CLEAR_CHAT_HISTORY_FINISH'
export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT'
export const SET_AGENT_CHAT_COUNT = 'SET_AGENT_CHAT_COUNT'
export const SET_DEPARTMENT_AGENT_CHAT_COUNT = 'SET_DEPARTMENT_AGENT_CHAT_COUNT'
export const CHANGE_SELECTED_DEPARTMENT_AGENT = 'CHANGE_SELECTED_DEPARTMENT_AGENT'
export const SET_DASHBOARD_CHAT_COUNT = 'SET_DASHBOARD_CHAT_COUNT'

// Constants for emailing chat messages
export const EMAIL_CHAT_MESSAGES = 'EMAIL_CHAT_MESSAGES'
export const EMAILED_CHAT_MESSAGES = 'EMAILED_CHAT_MESSAGES'

// Constants for customer context
export const CLEAR_CUSTOMER_CONTEXT = 'CLEAR_CUSTOMER_CONTEXT'
export const CLEAR_CUSTOMER_CONTEXT_FINISH = 'CLEAR_CUSTOMER_CONTEXT_FINISH'
export const SET_CUSTOMER_CONTEXT = 'SET_CUSTOMER_CONTEXT'
export const SET_CUSTOMER_CONTEXT_FINISH = 'SET_CUSTOMER_CONTEXT_FINISH'

// Constants for call actions
export const ENLARGE_VIDEO = 'ENLARGE_VIDEO'
export const SHRINK_VIDEO = 'SHRINK_VIDEO'

export const VIDEO_DISPLAY_STATUS = 'VIDEO_DISPLAY_STATUS'
// Constansts for canned messages
export const GET_COMPANY_CANNED_MESSAGES = 'GET_COMPANY_CANNED_MESSAGES'
export const GET_COMPANY_CANNED_MESSAGES_FINISH = 'GET_COMPANY_CANNED_MESSAGES_FINISH'
export const GET_AGENT_CANNED_MESSAGES = 'GET_AGENT_CANNED_MESSAGES'
export const GET_AGENT_CANNED_MESSAGES_FINISH = 'GET_AGENT_CANNED_MESSAGES_FINISH'
export const CREATE_AGENT_CANNED_MESSAGE = 'CREATE_AGENT_CANNED_MESSAGE'
export const CREATE_AGENT_CANNED_MESSAGE_FINISH = 'CREATE_AGENT_CANNED_MESSAGE_FINISH'
export const UPDATE_AGENT_CANNED_MESSAGE = 'UPDATE_AGENT_CANNED_MESSAGE'
export const UPDATE_AGENT_CANNED_MESSAGE_FINISH = 'UPDATE_AGENT_CANNED_MESSAGE_FINISH'
export const DELETE_AGENT_CANNED_MESSAGE = 'DELETE_AGENT_CANNED_MESSAGE'
export const DELETE_AGENT_CANNED_MESSAGE_FINISH = 'DELETE_AGENT_CANNED_MESSAGE_FINISH'

// Constants for Dashboard actions
export const TOGGLE_CHAT_PANEL = 'TOGGLE_CHAT_PANEL'
export const CHANGE_SELECTED_AGENT = 'CHANGE_SELECTED_AGENT'
//Agent Chat Messages
export const UPDATE_AGENT_CHAT_MESSAGE_BY_FULLUSERID_INITIATED = 'UPDATE_AGENT_CHAT_MESSAGE_BY_FULLUSERID_INITIATED'
export const UPDATE_AGENT_CHAT_MESSAGE_BY_FULLUSERID_FINISHED = 'UPDATE_AGENT_CHAT_MESSAGE_BY_FULLUSERID_FINISHED'
export const UPDATE_AGENT_CHAT_MESSAGE_BY_FULLUSERID_FAILURE = 'UPDATE_AGENT_CHAT_MESSAGE_BY_FULLUSERID_FAILURE'
export const UPDATE_AGENT_CHAT_MESSAGE_BY_UUID_INITIATED = 'UPDATE_AGENT_CHAT_MESSAGE_BY_UUID_INITIATED'
export const UPDATE_AGENT_CHAT_MESSAGE_BY_UUID_FINISHED = 'UPDATE_AGENT_CHAT_MESSAGE_BY_UUID_FINISHED'
export const UPDATE_AGENT_CHAT_MESSAGE_BY_UUID_FAILURE = 'UPDATE_AGENT_CHAT_MESSAGE_BY_UUID_FAILURE'

export const SEND_MESSAGE = 'SEND_MESSAGE'
export const MESSAGE_RECEIVED = 'MESSAGE_RECEIVED'
export const UPDATE_UN_READ_CHAT_MESSAGES_STATUS = 'UPDATE_UN_READ_CHAT_MESSAGES_STATUS'

export const SEND_SESSION_START_FINISH = 'SEND_SESSION_START_FINISH'

export const SET_TIMEOUT_STATUS = 'SET_TIMEOUT_STATUS'
export const USER_DATA_BASE = 'USER_DATA_BASE'
export const SESSION_REQ_TYPE = 'SESSION_REQ_TYPE'
export const IS_OR_NO_USER_INFO = 'IS_OR_NO_USER_INFO'
export const CLEAR_HINT_MSG_FOR_CUSTOMER = 'CLEAR_HINT_MSG_FOR_CUSTOMER'
export const UPDATE_COMPANY_BRAND_FINISH = 'UPDATE_COMPANY_BRAND_FINISH'
export const GET_COMPANY_DETAILS = 'GET_COMPANY_DETAILS'
export const SINGLE_FAILURE = 'SINGLE_FAILURE'
export const UPDATE_AGENT_PROFILE_FINISH = 'UPDATE_AGENT_PROFILE_FINISH'
export const CLEAR_HINT_MSG = 'CLEAR_HINT_MSG'
export const CLEAR_RESET_HINT_MSG = 'CLEAR_RESET_HINT_MSG'
export const RESET_PWD_FINISH = 'RESET_PWD_FINISH'

export const SAVE_COMPANY_EXPRESSION = 'SAVE_COMPANY_EXPRESSION'
export const CURRENT_SESSION_INFO = 'CURRENT_SESSION_INFO'
export const SAVE_INFO_BUT = 'SAVE_INFO_BUT'

export const CUSTOMLIST_IS_SHOW = 'CUSTOMLIST_IS_SHOW'
export const GET_CHATMESSAGE_HISTORY_FINISH = 'GET_CHATMESSAGE_HISTORY_FINISH'

export const QUERY_AGENTS_BYPAGE_FINISH='QUERY_AGENTS_BYPAGE_FINISH'
export const GET_RECENTCALL_FINISH='GET_RECENTCALL_FINISH'

//create agent
export const CREATE_AGENT_INITIATE='CREATE_AGENT_INITIATE'
export const CREATE_AGENT_FINISH='CREATE_AGENT_FINISH'

export const DELETE_ACCOUNT_INITIATE='DELETE_ACCOUNT_INITIATE'
export const DELETE_ACCOUNT_FINISH='DELETE_ACCOUNT_FINISH'

export const UPDATE_ACCOUNT_AVATAR_INITIATE='UPDATE_ACCOUNT_AVATAR_INITIATE'
export const UPDATE_ACCOUNT_AVATAR_FINISH='UPDATE_ACCOUNT_AVATAR_FINISH'

//wx

export const GET_ALL_OPER_LIST_FINISH='GET_ALL_OPER_LIST_FINISH'

export const GET_STATISTICCHART_FINISH='GET_STATISTICCHART_FINISH'
export const GET_CHARTDATA_FINISH='GET_CHARTDATA_FINISH'

export const GET_CONTROLCHARTDATA_FINISH='GET_CONTROLCHARTDATA_FINISH'
export const PAGENATION_OR_CHATBOX='PAGENATION_OR_CHATBOX'
export const GET_CUSTOMERBYID_FINISH='GET_CUSTOMERBYID_FINISH'
export const GET_CHART_HISTORY_FINISH='GET_CHART_HISTORY_FINISH'
export const GET_WXCHATMSG_HISTORY_FINISH='GET_WXCHATMSG_HISTORY_FINISH'
export const CLEAR_BRANDSET_MSG='CLEAR_BRANDSET_MSG'
export const CAN_DEL_CATEGORY_FINISH='CAN_DEL_CATEGORY_FINISH'
export const CLOSE_DEL_MODAL='CLOSE_DEL_MODAL'
export const GET_BUTTON_BY_PAGE_FINISH='GET_BUTTON_BY_PAGE_FINISH'
export const DELETE_BUTTON_FINISH='DELETE_BUTTON_FINISH'
export const CLEAR_DELETE_BUTTON_STATE='CLEAR_DELETE_BUTTON_STATE'
export const SAVE_CUSTOMER_BUTTON_START='SAVE_CUSTOMER_BUTTON_START'
export const CREATE_CUSTOMER_BUTTON_FINISH='CREATE_CUSTOMER_BUTTON_FINISH'
export const UPDATE_CUSTOMER_BUTTON_FINISH='UPDATE_CUSTOMER_BUTTON_FINISH'
export const UPDATE_WX_PUBLIC_ACCOUNT_FINISH='UPDATE_WX_PUBLIC_ACCOUNT_FINISH'



//customer list
export  const GET_CUSTOMER_LIST = 'GET_CUSTOMER_LIST'
export  const DELETE_CUSTOMER_INFO = 'DELETE_CUSTOMER_INFO'
export  const GET_CUSTOMER_BY_ID = 'GET_CUSTOMER_BY_ID'
export  const GET_CUSTOMER_REQUEST = 'GET_CUSTOMER_REQUEST'
export  const GET_CUSTOMER_CALL_RECORD = 'GET_CUSTOMER_CALL_RECORD'

export const SEND_RATE_FINISH='SEND_RATE_FINISH'

export const GET_SATISFACTIONCHART_FINISH='GET_SATISFACTIONCHART_FINISH'


export const CLOSE_GRAB_SINGLE_WARNING='CLOSE_GRAB_SINGLE_WARNING'

export  const UPDATE_CUSTOMER_ID = 'UPDATE_CUSTOMER_ID'

//agent Group

export const CURRENT_CALL_REQ = 'CURRENT_CALL_REQ'
export const CURRENT_CALL_STATUS = 'CURRENT_CALL_STATUS'
export const SHOW_FULL_SCREEN = 'SHOW_FULL_SCREEN'

export const EXPRESSIONUPDATE='EXPRESSIONUPDATE'
export const EXPRESSIONDESTORY='EXPRESSIONDESTORY'
export const EXPRESSIONERR='EXPRESSIONERR'


//wx video chat
export const WX_INVITE_VOIP='WX_INVITE_VOIP'
export const WX_HANGUP_VOIP='WX_HANGUP_VOIP'

export const WX_MPVOIPREADY='WX_MPVOIPREADY'
export const WX_MPVOIP_ANSWER_FINISH='WX_MPVOIP_ANSWER_FINISH'
export const WX_MPVOIP_HANGUP_FINISH='WX_MPVOIP_HANGUP_FINISH'

export const END_SESSION_LOSSASS='END_SESSION_LOSSASS'

export const WX_MPVOIP_SET_AUDIO_ENABLED='WX_MPVOIP_SET_AUDIO_ENABLED'

export const CREATE_ROLE_FINISH='CREATE_ROLE_FINISH'
export const DELETE_ROLE_START='DELETE_ROLE_START'
export const UPDATE_ROLE_START='UPDATE_ROLE_START'
export const SEARCH_ROLE_START = 'SEARCH_ROLE_START'
export const START_LOGIN='START_LOGIN'
export const USER_LOGIN_FINISH='USER_LOGIN_FINISH'

export const SET_AGENT_LOGOUT_FINISH='SET_AGENT_LOGOUT_FINISH'

export const GET_BUSINESSDATA_FINISH ='GET_BUSINESSDATA_FINISH'

export const GET_REPORT_STATISTIC_FINISH = 'GET_REPORT_STATISTIC_FINISH'
export const SEARCH_REPORT_FINISH = 'SEARCH_REPORT_FINISH'


export const GROUP_LIST_BY_REGION = 'GROUP_LIST_BY_REGION'

export const GET_DEPARTMENT_C = 'GET_DEPARTMENT_C'
export const CREATE_AGENTC_FINISH ='CREATE_AGENTC_FINISH'
export const UPDATE_AGENTC_FINISH ='UPDATE_AGENTC_FINISH'
export const DELETE_AGENTC_FINISH='DELETE_AGENTC_FINISH'
export const SAFETY_MECHANISM_LIST = 'SAFETY_MECHANISM_LIST'
export const CREATE_SAFETY_MECHANISM_FINISH = 'CREATE_SAFETY_MECHANISM_FINISH'
export const UPDATE_SAFETY_MECHANISM_FINISH = 'UPDATE_SAFETY_MECHANISM_FINISH'

export const DELETE_DEPARTMENT_FINISH = 'DELETE_DEPARTMENT_FINISH'
export const FORBID_SAFETYMECHANISM_FINISH = 'FORBID_SAFETYMECHANISM_FINISH'
export const DELETE_SAFETYMECHANISM_FINISH = 'DELETE_SAFETYMECHANISM_FINISH'

export const UPDATE_AGENT_LOGIN_STATE = 'UPDATE_AGENT_LOGIN_STATE'
export const UPDATE_AGENT_SERVICE_STATUS = 'UPDATE_AGENT_SERVICE_STATUS'
export const SET_AGENT_SERVICE_STATUS_FINISH = 'SET_AGENT_SERVICE_STATUS_FINISH'
export const KICK_OUT_AGENT_FINISH = 'KICK_OUT_AGENT_FINISH'

export const SCENE_WORKLOAD_FINISH = "SCENE_WORKLOAD_FINISH"
export const AGENTS_WORKLOAD_FINISH = "AGENTS_WORKLOAD_FINISH"
export const TASK_STATISTICS_FINISH = "TASK_STATISTICS_FINISH"
export const CREATE_COMPANIES_FINISH = "CREATE_COMPANIES_FINISH"
export const CREATE_COMPANIES_FAIL = "CREATE_COMPANIES_FAIL"
export const UPDATE_COMPANIES_FINISH = 'UPDATE_COMPANIES_FINISH'
export const UPDATE_COMPANIES_FAIL = 'UPDATE_COMPANIES_FAIL'

export const GET_POLICIES_SUCCESS = 'GET_POLICIES_SUCCESS'
export const GET_POLICIES_FALIED = 'GET_POLICIES_FALIED'
export const CLEAR_POLICIES = 'CLEAR_POLICIES'
export const GET_HORSEMAN_POLICIES_FALIED = 'GET_HORSEMAN_POLICIES_FALIED'


// 5g视频通讯
export const CALL_INIT = Symbol('CALL-INIT');
export const CALL_STATUS_CHANGE = Symbol('CALL_STATUS_CHANGE')
export const MEDIA_CHANGE = Symbol('MEDIA-CHANGE')
export const CALL_DURATION_CHANGE = Symbol('CALL_DURATION_CHANGE');
export const CALL_END = Symbol('END');
export const CALL_CONNECTED = Symbol('CALL_CONNECTED');

// 工单详情备注操作
export const REMARK_CHANGE = Symbol('REMARK_CHANGE');
export const REMARK_INIT = Symbol('REMARK_INIT');

// uploadReducer
export const CHANGE_UPLOAD_STATUS = Symbol('CHANGE_UPLOAD_STATUS');
export const ADD_UPLOAD_ITEM = Symbol('ADD_UPLOAD_ITEM');
export const CLEAR_UPLOAD = Symbol('CLEAR_UPLOAD');